import { TranslationObject } from '@ngx-translate/core';
import { Location } from '@lib.core/entities/location/location';

export interface LocationDTO {
  geoCode: string;
  geoType: string;
  title: TranslationObject;
  boundingBox?: string;
  countryCode?: string;
}

export function newLocationEntityFromDto(dto: LocationDTO): Location {
  return new Location(dto.geoCode, dto.geoType, dto.title, dto.boundingBox, dto.countryCode);
}
